import React from 'react';
import { createView, view } from '@sail/ui';
import { helmTokens } from '../../theme';
export const CheckTransparent = createView((props)=>{
    return /*#__PURE__*/ React.createElement(view.svg, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement(view.g, {
        css: {
            fill: `${helmTokens.color.accentColor}`
        },
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("circle", {
        opacity: ".15",
        cx: "8",
        cy: "8",
        r: "8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.41 4.93L6.64 9.54 5.38 8.18a.7.7 0 0 0-.87-.04.61.61 0 0 0-.18.8l1.5 2.45c.15.22.41.36.69.36.28 0 .53-.14.68-.36.24-.31 4.82-5.78 4.82-5.78.6-.6-.13-1.15-.6-.68z"
    })));
});

//# sourceMappingURL=CheckTransparent.js.map